module.exports = __webpack_public_path__ + "static/media/diamonds_7.a9922378.png";